/**
 * 取得済み登記（requested-pictures）用のタグ同期システム
 * PropertySelectionGridと取得済み登記ポップアップ間でタグデータを同期するためのユーティリティ
 */

import { createPropertyGridPopupSyncSystem } from "./createSyncSystem";

export const REQUESTED_PICTURES_TAG_UPDATE_EVENT =
  "updateRequestedPicturesTags";

const { dispatch, addListener } = createPropertyGridPopupSyncSystem<string[]>(
  REQUESTED_PICTURES_TAG_UPDATE_EVENT
);

/**
 * 取得済み登記のタグ更新イベントを発火する
 * ポップアップが開かれた際に最新のタグでフォームを更新するために使用
 * @param tags 更新するタグの配列
 */
export const dispatchRequestedPicturesTagUpdate = (tags: string[]): void => {
  dispatch(tags);
};

/**
 * 取得済み登記のタグ更新イベントリスナーを追加する
 * @param callback タグが更新された際に呼び出されるコールバック関数
 * @returns クリーンアップ関数
 */
export const addRequestedPicturesTagUpdateListener = (
  callback: (tags: string[]) => void
): (() => void) => {
  return addListener(callback);
};
